import { render, staticRenderFns } from "./ForgotConfirm.vue?vue&type=template&id=4c748e8d&"
import script from "./ForgotConfirm.vue?vue&type=script&lang=js&"
export * from "./ForgotConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports